import React from 'react'
import Image from "next/image";
import Head from "next/head";
import styles from "../about-upsc/about-upsc.module.css";


const About_Civil_Service = () => {
        
  return (
    <>
    {/* Civil Service Examination */}
   <div className="container">
                    <div className="row">
                        <div className="col">
                            <h2 className={`${styles.sectiontitle} mb-0`}>Overview</h2>
                            <h2 className={`${styles.sectiontitle} mb-0 pb-md-2`}>Civil Service Examination</h2>
                            <p className={`${styles.acheiverrank} pt-md-2`}>Civil service, which is the backbone of Indian governance constitutes 
                                all ministries and their departments. The Civil service and Forest service exams are conducted by the UPSC. 
                                The prestige, power, charm and responsibility that come along with the top jobs such as the IAS, IFS, IPS, etc., 
                                are a definite reason for anyone to choose Civil service and Forest service a career option.</p>
                        </div>
                    </div>
                </div>
                
              
                <div className="container">
                    <div className="row pt-3">
                        <div className="col">
                            <h2 className={`${styles.sectiontitle} mb-0 pb-md-2`}>Eligibility</h2>
                            <p className={`${styles.aboutparagraph1} p-2`}><span className={`${styles.dot}`}>*</span>&nbsp; &nbsp; <span>Must have attained the age of 21 on 1st August of year of examination.</span></p>
                            <p className={`${styles.aboutparagraph1} p-2`}><span className={`${styles.dot}`}>*</span>&nbsp; &nbsp; <span>Must not have attained 32 years(35|37 years) on 1st August of year of examination.</span></p>
                        </div>
                    </div>
                </div>
                

                
                <div className="container"> 
                    <div className="row pt-3">
                        <div className="col">
                            <p className={`${styles.aboutheading1} mb-0 pb-md-2`}>Education</p>
                            <p className={`${styles.acheiverrank}`}><span className={`${styles.dot}`}>*</span>&nbsp; &nbsp; Any Degree (Recognized by UGC/AICTE)</p>
                           
                        </div>         
                    </div>
                </div>

                {/*Age Criteria Section*/}

                <div className="container">
                    <div className="row">
                        <div className="col">
                            <p className={`${styles.aboutheading1}`}>Age Criteria</p>
                            <div className="row">

                                <div className="col-xl-3 col-lg-4 col-md-6 col-12 mb-3">
                                       <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                          <p className={`${styles.aboutheading2}`}>General</p>
                                          <div className="row">
                                                <div className="col">
                                                <p className={`${styles.acheiverrank}`}>Minimum Age</p>
                                                </div>
                                                <div className="col">
                                                <p className={`${styles.aboutnumber}`}>21</p>
                                                </div>
                                          </div>
                                          <div className="row">
                                                <div className="col">
                                                <p className={`${styles.agecontent}`}>Maximum Age</p>
                                                </div>
                                                <div className="col">
                                                <p className={`${styles.aboutnumber}`}>32</p>
                                                </div>
                                          </div>
                                          <div className="row">
                                                <div className="col">
                                                <p className={`${styles.agecontent}`}>No of attempts</p>
                                                </div>
                                                <div className="col">
                                                <p className={`${styles.aboutnumber}`}>6</p>
                                                </div>
                                          </div>
                                    </div>
                                </div>



                                <div className="col-xl-3 col-lg-4 col-md-6 col-12 mb-3">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading2}`}>OBC</p>
                                            <div className="row">
                                                    <div className="col">
                                                    <p className={`${styles.acheiverrank}`}>Minimum Age</p>
                                                    </div>
                                                    <div className="col">
                                                    <p className={`${styles.aboutnumber}`}>21</p>
                                                    </div>
                                            </div>
                                            <div className="row">
                                                    <div className="col">
                                                    <p className={`${styles.agecontent}`}>Maximum Age</p>
                                                    </div>
                                                    <div className="col">
                                                    <p className={`${styles.aboutnumber}`}>35</p>
                                                    </div>
                                            </div>
                                            <div className="row">
                                                    <div className="col">
                                                    <p className={`${styles.agecontent}`}>No of attempts</p>
                                                    </div>
                                                    <div className="col">
                                                    <p className={`${styles.aboutnumber}`}>9</p>
                                                    </div>
                                            </div>
                                    </div>
                                </div>

                                <div className="col-xl-3 col-lg-4 col-md-6 col-12 pt-md-3 pt-lg-0 mb-3">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                         <p className={`${styles.aboutheading2}`}>SC & ST</p>
                                        <div className="row">
                                                <div className="col">
                                                <p className={`${styles.acheiverrank}`}>Minimum Age</p>
                                                </div>
                                                <div className="col">
                                                <p className={`${styles.aboutnumber}`}>21</p>
                                                </div>
                                        </div>
                                        <div className="row">
                                                <div className="col">
                                                <p className={`${styles.agecontent}`}>Maximum Age</p>
                                                </div>
                                                <div className="col">
                                                <p className={`${styles.aboutnumber}`}>37</p>
                                                </div>
                                        </div>
                                        <div className="row">
                                                <div className="col">
                                                <p className={`${styles.agecontent}`}>No of attempts</p>
                                                </div>
                                                <div className="col">
                                                <p className={`${styles.aboutnumber}`}>No limits</p>
                                                </div>
                                        </div>
                                    </div>   
                                </div>
                                
                            </div>
                        </div>         
                    </div>
                </div>

                {/* Exam Schedules Section*/}

                <div className="container">
                    <div className="row pt-3">
                        <div className="col-lg-7 col-md-9 col-12">
                           <h2 className={`${styles.sectiontitle}`}>Exam Schedules</h2>

                           <div className="row mx-auto">
                                <div className="col ps-0">
                                    <p className={`${styles.acheiverrank}`}>Notification</p>
                                </div>
                                <div className="col">
                                    <p className={`${styles.acheiverrank}`}>February / March</p>
                                </div>
                                <hr></hr>
                           </div>

                           <div className="row mx-auto">
                                <div className="col ps-0">
                                    <p className={`${styles.acheiverrank}`}>Preliminary Examination</p>
                                </div>
                                <div className="col">
                                    <p className={`${styles.acheiverrank}`}>May / June</p>
                                </div>
                                <hr></hr>
                           </div>

                           <div className="row mx-auto">
                                <div className="col ps-0">
                                    <p className={`${styles.acheiverrank}`}>Preliminary Exam Results</p>
                                </div>
                                <div className="col">
                                    <p className={`${styles.acheiverrank}`}>July / August</p>
                                </div>
                                <hr></hr>
                           </div>

                           <div className="row mx-auto">
                                <div className="col ps-0">
                                    <p className={`${styles.acheiverrank}`}>Mains Examinations</p>
                                </div>
                                <div className="col">
                                    <p className={`${styles.acheiverrank}`}>September / October</p>
                                </div>
                                <hr></hr>
                           </div>

                           <div className="row mx-auto">
                                <div className="col ps-0">
                                    <p className={`${styles.acheiverrank}`}>Mains Exam Results</p>
                                </div>
                                <div className="col">
                                    <p className={`${styles.acheiverrank}`}>February 1st week / 2nd week</p>
                                </div>
                                <hr></hr>
                           </div>

                           <div className="row mx-auto">
                                <div className="col ps-0">
                                    <p className={`${styles.acheiverrank}`}>Interview</p>
                                </div>
                                <div className="col">
                                    <p className={`${styles.acheiverrank}`}>March - April</p>
                                </div>
                                <hr></hr>
                           </div>

                           <div className="row mx-auto">
                                <div className="col ps-0">
                                    <p className={`${styles.acheiverrank}`}>Final Results</p>
                                </div>
                                <div className="col">
                                    <p className={`${styles.acheiverrank}`}>May</p>
                                </div>
                                <hr></hr>
                           </div>

                        </div>
                    </div>
                </div>

{/* Forest Service Examination */}
<div className="container">
                    <div className="row">
                        <div className="col">
                            <h2 className={`${styles.sectiontitle} mb-0 pb-md-2`}>Forest Service Examination</h2>
                        </div>
                    </div>
                </div>
                
              
                <div className="container">
                    <div className="row pt-3">
                        <div className="col">
                            <h2 className={`${styles.sectiontitle} mb-0 pb-md-2`}>Eligibility</h2>
                            <p className={`${styles.aboutparagraph1} p-2`}><span className={`${styles.dot}`}>*</span>&nbsp; &nbsp; <span>Must have attained the age of 21 before 1st on of year of examination.</span></p>
                            <p className={`${styles.aboutparagraph1} p-2`}><span className={`${styles.dot}`}>*</span>&nbsp; &nbsp; <span>Must not have attained 32 years(35|37 years) on 1st August of year of examination.</span></p>
                        </div>
                    </div>
                </div>
                

                
                <div className="container"> 
                    <div className="row pt-3">
                        <div className="col">
                            <p className={`${styles.aboutheading1} mb-0 pb-md-2`}>Education</p>
                            <p className={`${styles.acheiverrank}`}><span className={`${styles.dot}`}>*</span>&nbsp; &nbsp;Bachelor’s Degree with atleast one of the subjects namely Animal Husbandry and Veterinary Science, Physics, Chemistry, Botany, Zoology, Geology, Mathematics and Statistics
                                (or)Bachelor Degree in Agriculture, Forestry (or) Engineering (Recognized by UGC/AICTE)
                            </p>
                           
                        </div>         
                    </div>
                </div>

                {/*Age Criteria Section*/}

                <div className="container">
                    <div className="row">
                        <div className="col">
                            <p className={`${styles.aboutheading1}`}>Age Criteria</p>
                            <div className="row">

                                <div className="col-xl-3 col-lg-4 col-md-6 col-12 mb-3">
                                       <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                          <p className={`${styles.aboutheading2}`}>General</p>
                                          <div className="row">
                                                <div className="col">
                                                <p className={`${styles.acheiverrank}`}>Minimum Age</p>
                                                </div>
                                                <div className="col">
                                                <p className={`${styles.aboutnumber}`}>21</p>
                                                </div>
                                          </div>
                                          <div className="row">
                                                <div className="col">
                                                <p className={`${styles.agecontent}`}>Maximum Age</p>
                                                </div>
                                                <div className="col">
                                                <p className={`${styles.aboutnumber}`}>32</p>
                                                </div>
                                          </div>
                                          <div className="row">
                                                <div className="col">
                                                <p className={`${styles.agecontent}`}>No of attempts</p>
                                                </div>
                                                <div className="col">
                                                <p className={`${styles.aboutnumber}`}>6</p>
                                                </div>
                                          </div>
                                    </div>
                                </div>



                                <div className="col-xl-3 col-lg-4 col-md-6 col-12 mb-3">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading2}`}>OBC</p>
                                            <div className="row">
                                                    <div className="col">
                                                    <p className={`${styles.acheiverrank}`}>Minimum Age</p>
                                                    </div>
                                                    <div className="col">
                                                    <p className={`${styles.aboutnumber}`}>21</p>
                                                    </div>
                                            </div>
                                            <div className="row">
                                                    <div className="col">
                                                    <p className={`${styles.agecontent}`}>Maximum Age</p>
                                                    </div>
                                                    <div className="col">
                                                    <p className={`${styles.aboutnumber}`}>35</p>
                                                    </div>
                                            </div>
                                            <div className="row">
                                                    <div className="col">
                                                    <p className={`${styles.agecontent}`}>No of attempts</p>
                                                    </div>
                                                    <div className="col">
                                                    <p className={`${styles.aboutnumber}`}>9</p>
                                                    </div>
                                            </div>
                                    </div>
                                </div>

                                <div className="col-xl-3 col-lg-4 col-md-6 col-12 pt-md-3 pt-lg-0 mb-3">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                         <p className={`${styles.aboutheading2}`}>SC & ST</p>
                                        <div className="row">
                                                <div className="col">
                                                <p className={`${styles.acheiverrank}`}>Minimum Age</p>
                                                </div>
                                                <div className="col">
                                                <p className={`${styles.aboutnumber}`}>21</p>
                                                </div>
                                        </div>
                                        <div className="row">
                                                <div className="col">
                                                <p className={`${styles.agecontent}`}>Maximum Age</p>
                                                </div>
                                                <div className="col">
                                                <p className={`${styles.aboutnumber}`}>37</p>
                                                </div>
                                        </div>
                                        <div className="row">
                                                <div className="col">
                                                <p className={`${styles.agecontent}`}>No of attempts</p>
                                                </div>
                                                <div className="col">
                                                <p className={`${styles.aboutnumber}`}>No limits</p>
                                                </div>
                                        </div>
                                    </div>   
                                </div>
                                
                            </div>
                        </div>         
                    </div>
                </div>

                {/* Exam Schedules Section*/}

                <div className="container">
                    <div className="row pt-3">
                        <div className="col-lg-7 col-md-9 col-12">
                           <h2 className={`${styles.sectiontitle}`}>Exam Schedules</h2>

                           <div className="row mx-auto">
                                <div className="col ps-0">
                                    <p className={`${styles.acheiverrank}`}>Notification</p>
                                </div>
                                <div className="col">
                                    <p className={`${styles.acheiverrank}`}>February / March</p>
                                </div>
                                <hr></hr>
                           </div>

                           <div className="row mx-auto">
                                <div className="col ps-0">
                                    <p className={`${styles.acheiverrank}`}>Preliminary Examination</p>
                                </div>
                                <div className="col">
                                    <p className={`${styles.acheiverrank}`}>May / June</p>
                                </div>
                                <hr></hr>
                           </div>

                           <div className="row mx-auto">
                                <div className="col ps-0">
                                    <p className={`${styles.acheiverrank}`}>Preliminary Exam Results</p>
                                </div>
                                <div className="col">
                                    <p className={`${styles.acheiverrank}`}>July / August</p>
                                </div>
                                <hr></hr>
                           </div>

                           <div className="row mx-auto">
                                <div className="col ps-0">
                                    <p className={`${styles.acheiverrank}`}>Mains Examinations</p>
                                </div>
                                <div className="col">
                                    <p className={`${styles.acheiverrank}`}>November / December</p>
                                </div>
                                <hr></hr>
                           </div>

                           <div className="row mx-auto">
                                <div className="col ps-0">
                                    <p className={`${styles.acheiverrank}`}>Mains Exam Results</p>
                                </div>
                                <div className="col">
                                    <p className={`${styles.acheiverrank}`}>January 1st Week / 2nd Week</p>
                                </div>
                                <hr></hr>
                           </div>

                           <div className="row mx-auto">
                                <div className="col ps-0">
                                    <p className={`${styles.acheiverrank}`}>Interview</p>
                                </div>
                                <div className="col">
                                    <p className={`${styles.acheiverrank}`}>January / February</p>
                                </div>
                                <hr></hr>
                           </div>

                           <div className="row mx-auto">
                                <div className="col ps-0">
                                    <p className={`${styles.acheiverrank}`}>Final Results</p>
                                </div>
                                <div className="col">
                                    <p className={`${styles.acheiverrank}`}>February / March</p>
                                </div>
                                <hr></hr>
                           </div>

                        </div>
                    </div>
                </div>

</>
  )
}

export default About_Civil_Service;